<template>
    <el-menu default-active="1-4-1" class="el-menu-vertical-demo"  background-color="#545c64"  text-color="#fff"  active-text-color="#ffd04b" @open="handleOpen" @close="handleClose" :collapse="isCollapse">
        <h3 style="text-align:center"><img src="../assets/log.png" alt="" class="imgs">合同管理系统</h3>
        <template v-for="item in menuList">
            <template >
                <el-submenu :index="item.index" v-if="item.children" :key="item.index">
                    <template slot="title"><i :class="item.icon"></i>{{item.title}}</template>
                    <el-menu-item-group>
                        <el-menu-item :index="item1.index" @click="goPage(item1)" v-for="item1 in item.children" :key="item1.index">{{item1.title}}</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                 <el-menu-item :index="item.index" v-else  @click="goPage(item)" :key="item.index">
                    <i :class="item.icon"></i>
                    <span slot="title">{{item.title}}</span>
                </el-menu-item>
            </template>
           
        </template>
    </el-menu>
</template>
<style lang="less" scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
  }
  .el-menu{
        height:100%;
        border:none;
        h3{
            color:#fff;
            text-align:center;
            line-height:48px;
        }
  }
   .imgs{
        width:50px;
        height:50px;
        vertical-align:middle;
    }
</style>

<script>
import {getNavigation} from '@/utils/api'
  export default {
    data() {
      return {
        isCollapse: false,
        menuList:[
			{
				title:'系统管理',
				icon:'el-icon-s-platform',
				index:'1',
                path:'/userGl'
			},
            {
				title:'项目管理',
				icon:'el-icon-s-data',
				index:'2',
                path:'/Warehousing'
			},
            {
				title:'预收益管理',
				icon:'el-icon-menu',
				index:'3',
                 path:'/QueryPricing'
			},
            {
				title:'设备管理',
				icon:'el-icon-s-cooperation',
				index:'4',
                path:'/Stock'
			},
            
		]
      };
    },
    props:{
        list:{
            type:Array,
            default:()=>{
                return []
            }
        }
    },
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        goPage(item) {
           //console.log(item)
           this.$router.push(item.path).catch(err => err)
            //this.$emit('getType',item.index)  
        },
    },
    mounted(){
        let user=JSON.parse(localStorage.getItem('userInfo'))
        let param ={
            roleid:user.roleId
        }
        // getNavigation(param).then(res=>{
        //     this.menuList=res;
        // })
    },
    computed:{

    }
  }
</script>


// WEBPACK FOOTER //
// src/components/comAside.vue